<template>
    <div id="navReturn" class="navReturn" >
        <Button icon="back" slot="left" @click.native="goback()"></Button>
        <!-- <span  @click.native="goback()" class="icon icon-xiangzuo"></span> -->
    </div>
  </template>
  <script>
    import { Button } from 'mint-ui'
    import 'mint-ui/lib/style.css'
  export default {
    name: "navReturn",
    props: {},
    components:{
        Button
    },
    data: function() {
      return {

      };
    },
    methods: {
        goback(){
            this.$router.go(-1);
        }
    }
  };
  </script>
  <style scoped>
      .navReturn{
        width:  0.6rem;
        height: 0.6rem;
        position: fixed;
        top: .3rem;
        margin-left: 0.3rem;
        z-index: 9999;
      }
      .navReturn button{
        width:  0.6rem;
        height: 0.6rem;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        text-align: center;
        line-height: 0.5rem;
        color: #fff;
        padding: 0px;
      }
  </style>
